import React from "react";
import { checkForOverride, glow, linearGradient } from "../helpers/theme";
import { ReplaceWithDataSource } from "../helpers/variable";

import "../styles/lower-third-animated-stretch.css";

export default function LowerThirdAnimated({
	cue,
	baseTheme,
	baseThemeId,
	isPreview = false,
}) {
	return (
		<>
			<span
				style={{
					boxShadow: glow(
						baseTheme,
						cue.type,
						cue.preset,
						"background",
						"glowBlur"
					),
					background:
						["stretch"].includes(cue.animationName) &&
						linearGradient(
							baseTheme,
							cue.type,
							cue.preset,
							"background",
							"colour"
						),
					borderLeft: `${
						checkForOverride(
							baseTheme,
							"lower_third",
							cue.preset,
							"border",
							"sides"
						)[2] === "1"
							? baseTheme.border.size
							: 0
					}vw ${checkForOverride(
						baseTheme,
						"lower_third",
						cue.preset,
						"border",
						"style"
					)} ${checkForOverride(
						baseTheme,
						"lower_third",
						cue.preset,
						"border",
						"colour"
					)}`,
				}}
				className={`${cue.type}
						${
							(cue.status === "cued" && isPreview) ||
							cue.status === "onair" ||
							cue.status === "coming" ||
							(cue.status === "cuedoff" && !isPreview) ||
							cue.status === "going"
								? "opacity-100"
								: "opacity-0"
						}
						
						flex
						${
							["bl", "ml", "tl"].includes(cue.position) &&
							!["slide-out"].includes(cue.animationName) &&
							"items-start"
						}
						${
							["bc", "mc", "tc"].includes(cue.position) &&
							!["slide-out"].includes(cue.animationName) &&
							"items-center"
						}
						${
							["br", "mr", "tr"].includes(cue.position) &&
							!["slide-out"].includes(cue.animationName) &&
							"items-end"
						}
						
						animated_${cue.animationName}_holder ${
					(cue.status === "cued" && isPreview) ||
					cue.status === "coming" ||
					cue.status === "onair" ||
					(cue.status === "cuedoff" && !isPreview)
						? `animated_${cue.animationName}_animate-in`
						: `animated_${cue.animationName}_animate-out`
				}

        `}
			>
				{/* SMALL TEXT */}
				{cue.line_two && (
					<span
						style={{
							fontFamily: baseTheme.h2?.font || baseTheme.font?.family,
							color: checkForOverride(
								baseTheme,
								"lower_third",
								cue.preset,
								"h2",
								"colour"
							),
							fontWeight:
								checkForOverride(
									baseTheme,
									"lower_third",
									cue.preset,
									"h2",
									"bold"
								) === true
									? "bold"
									: "normal",
							fontStyle:
								checkForOverride(
									baseTheme,
									"lower_third",
									cue.preset,
									"h2",
									"italic"
								) === true
									? "italic"
									: "normal",
							textDecoration:
								checkForOverride(
									baseTheme,
									"lower_third",
									cue.preset,
									"h2",
									"underline"
								) === true
									? "underline"
									: "none",
							background:
								!["stretch"].includes(cue.animationName) &&
								linearGradient(
									baseTheme,
									cue.type,
									cue.preset,
									"background",
									"colour"
								),
							filter: `${
								baseTheme?.["lower_third_animated"]?.["second_line_opacity"] === true
									? "brightness(90%)"
									: "brightness(100%)"
							}`,
						}}
						className={` key_me ${baseThemeId}_${
							cue.type
						}_small_text ${baseThemeId}_small_text small_text 

							animated_${cue.animationName}_small ${
							(cue.status === "cued" && isPreview) ||
							cue.status === "coming" ||
							cue.status === "onair" ||
							(cue.status === "cuedoff" && !isPreview)
								? `animated_${cue.animationName}_small-animate-in`
								: `animated_${cue.animationName}_small-animate-out`
						}
						px-${checkForOverride(
							baseTheme,
							"lower_third",
							cue.preset,
							"background",
							"paddingX"
						)}
						py-${checkForOverride(
							baseTheme,
							"lower_third",
							cue.preset,
							"background",
							"paddingY"
						)}
						text-${checkForOverride(baseTheme, "lower_third", cue.preset, "h2", "size")}
						leading-${checkForOverride(
							baseTheme,
							"lower_third",
							cue.preset,
							"h2",
							"leading"
						)}
						whitespace-pre
                    `}
					>
						<ReplaceWithDataSource text={cue.line_two} styled={true} />
					</span>
				)}
				{["stretch"].includes(cue.animationName) && (
					<span
						className={`animated_${cue.animationName}_seperator`}
						style={{
							background: checkForOverride(
								baseTheme,
								"lower_third",
								cue.preset,
								"border",
								"colour"
							),
						}}
					></span>
				)}
				{/* LARGE TEXT */}
				<span
					style={{
						fontFamily: baseTheme.h1?.font || baseTheme.font?.family,
						color: checkForOverride(
							baseTheme,
							"lower_third",
							cue.preset,
							"h1",
							"colour"
						),
						fontWeight:
							checkForOverride(
								baseTheme,
								"lower_third",
								cue.preset,
								"h1",
								"bold"
							) === true
								? "bold"
								: "normal",
						fontStyle:
							checkForOverride(
								baseTheme,
								"lower_third",
								cue.preset,
								"h1",
								"italic"
							) === true
								? "italic"
								: "normal",
						textDecoration:
							checkForOverride(
								baseTheme,
								"lower_third",
								cue.preset,
								"h1",
								"underline"
							) === true
								? "underline"
								: "none",
						background:
							!["stretch"].includes(cue.animationName) &&
							linearGradient(
								baseTheme,
								cue.type,
								cue.preset,
								"background",
								"colour"
							),
					}}
					className={`key_me ${baseThemeId}_${
						cue.type
					}_large_text ${baseThemeId}_large_text large_text 
							animated_${cue.animationName}_large ${
						(cue.status === "cued" && isPreview) ||
						cue.status === "coming" ||
						cue.status === "onair" ||
						(cue.status === "cuedoff" && !isPreview)
							? `animated_${cue.animationName}_large-animate-in`
							: `animated_${cue.animationName}_large-animate-out`
					}

						px-${checkForOverride(
							baseTheme,
							"lower_third",
							cue.preset,
							"background",
							"paddingX"
						)}
						py-${checkForOverride(
							baseTheme,
							"lower_third",
							cue.preset,
							"background",
							"paddingY"
						)}
						text-${checkForOverride(baseTheme, "lower_third", cue.preset, "h1", "size")}
						leading-${checkForOverride(
							baseTheme,
							"lower_third",
							cue.preset,
							"h1",
							"leading"
						)}
						whitespace-pre
                    `}
				>
					<ReplaceWithDataSource text={cue.line_one} styled={true} />
				</span>
			</span>
		</>
	);
}
